import Login from './Login'
import Browse from './Browse'
import WatchTrailer from './Trailer/WatchTrailer'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'

const Body = () => {

    const appRouter = createBrowserRouter([
        {
            path:"/",
            element: <Login />,
        },
        {
            path:"/browse",
            element: <Browse />,
        },
        {
            path: "/watch",
            element: <WatchTrailer />,
          }
    ]);

  return (
    <div>
       <RouterProvider router = {appRouter} />
        </div>
  )
}

export default Body